(function () {
  'use strict';

  var CARD_SELECTOR = '.collection-card.w-dyn-item, .boost-pfs-filter-product-item';
  var FRAME_SELECTOR = '.blog33_image-wrapper-2, .gallery21_image-wrapper, .boost-pfs-filter-product-item-image-link';

  function lower(value) {
    return (value || '').toString().toLowerCase();
  }

  function isAstierBrandPage() {
    var heading = document.querySelector('h1, .mn-brand-heading');
    var headingText = heading ? lower(heading.textContent) : '';
    var query = lower(window.location.search);
    try { query = lower(decodeURIComponent(window.location.search)); } catch (error) {}
    return headingText.indexOf('astier de villatte') !== -1 ||
      query.indexOf('astier de villatte') !== -1 ||
      document.querySelector('.mn-astier-brand-results-page') !== null;
  }

  function isAstierCard(card, forceBrandPage) {
    if (forceBrandPage) return true;
    var link = card.querySelector('a[href*="/products/"]');
    var image = card.querySelector('img');
    var identity = lower([
      link ? link.getAttribute('href') : '',
      card.textContent || '',
      image ? image.getAttribute('alt') : '',
      card.getAttribute('data-vendor') || ''
    ].join(' '));
    return identity.indexOf('astier-de-villatte') !== -1 ||
      identity.indexOf('astier de villatte') !== -1;
  }

  function important(element, property, value) {
    element.style.setProperty(property, value, 'important');
  }

  function styleFrame(frame) {
    frame.classList.add('mn-astier-direct-frame');
    important(frame, 'position', 'relative');
    important(frame, 'width', '100%');
    important(frame, 'height', '0');
    important(frame, 'padding-top', '125%');
    important(frame, 'overflow', 'hidden');
    important(frame, 'background', '#F5F0E8');
    important(frame, 'isolation', 'isolate');
  }

  function styleImage(image) {
    if (!image) return;
    image.classList.add('mn-astier-direct-image');

    var ratio = image.naturalWidth && image.naturalHeight ? image.naturalWidth / image.naturalHeight : 1;
    var width = '80%';
    var maxHeight = '80%';
    var ratioClass = 'mn-astier-source-square';

    image.classList.remove('mn-astier-source-landscape', 'mn-astier-source-square', 'mn-astier-source-portrait');

    if (ratio >= 1.08) {
      width = '76%';
      maxHeight = '72%';
      ratioClass = 'mn-astier-source-landscape';
    } else if (ratio < 0.92) {
      width = '84%';
      maxHeight = '84%';
      ratioClass = 'mn-astier-source-portrait';
    }

    image.classList.add(ratioClass);
    important(image, 'position', 'absolute');
    important(image, 'inset', 'auto');
    important(image, 'top', '50%');
    important(image, 'left', '50%');
    important(image, 'right', 'auto');
    important(image, 'bottom', 'auto');
    important(image, 'display', 'block');
    important(image, 'width', width);
    important(image, 'height', 'auto');
    important(image, 'max-width', width);
    important(image, 'max-height', maxHeight);
    important(image, 'margin', '0');
    important(image, 'padding', '0');
    important(image, 'object-fit', 'contain');
    important(image, 'object-position', 'center');
    important(image, 'transform', 'translate(-50%, -50%)');
    important(image, 'mix-blend-mode', 'darken');
    important(image, 'background', 'transparent');
  }

  function processCard(card, forceBrandPage) {
    if (!card || !card.querySelector || !isAstierCard(card, forceBrandPage)) return;
    var frame = card.querySelector(FRAME_SELECTOR);
    if (!frame) return;
    var image = frame.querySelector('img');
    styleFrame(frame);
    styleImage(image);
    if (image && !image.complete) {
      image.addEventListener('load', function () { styleImage(image); }, { once: true });
    }
  }

  function initialise(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var forceBrandPage = isAstierBrandPage();

    if (scope.matches && scope.matches(CARD_SELECTOR)) processCard(scope, forceBrandPage);
    scope.querySelectorAll(CARD_SELECTOR).forEach(function (card) {
      processCard(card, forceBrandPage);
    });
  }

  function start() {
    initialise(document);
    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) initialise(node);
          });
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}());
